import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { SendPharmaVerifyEmailParams, SendPharmaVerifyEmailResponse } from 'types/api/auth';
import { type ApiError, faksApiInstance as api } from './api';

export const useSendPharmacyVerificationEmail = (
  options?: UseMutationOptions<
    SendPharmaVerifyEmailResponse,
    AxiosError<ApiError>,
    SendPharmaVerifyEmailParams
  >
): UseMutationResult<
  SendPharmaVerifyEmailResponse,
  AxiosError<ApiError>,
  SendPharmaVerifyEmailParams
> =>
  useMutation({
    mutationFn: (params) =>
      api.post<SendPharmaVerifyEmailResponse>(
        `pharmacies/${params.pharmacyId}/_send_verify_pharmacy_email`
      ),

    ...options,
  });
